import { ObservableArray, View } from "binder"
import { CompareDistrictSalesViewModel, } from "./compareDistrictSales-viewModel"
import { DistrictSalesTabViewModel } from "../districtSalesTab/districtSalesTab-viewModel";

export class CompareDistrictSalesView extends View<CompareDistrictSalesViewModel>{
    GetViewUniqueId(): string {
        return "V-A52F4445-7B6A-4390-9B59-734644409707"
    }
    loadHtml(): string {
        let element = require('./compareDistrictSales.html').default;
        let style = require('./compareDistrictSales.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set compareDistrictTabs(v: ObservableArray<DistrictSalesTabViewModel>) { this._compareDistrictTabs = v; } public get compareDistrictTabs(): ObservableArray<DistrictSalesTabViewModel> { return this._compareDistrictTabs;} private _compareDistrictTabs: ObservableArray<DistrictSalesTabViewModel>;
    public set selectedCompareDistrictTab(v: DistrictSalesTabViewModel) { this._selectedCompareDistrictTab = v; } public get selectedCompareDistrictTab(): DistrictSalesTabViewModel { return this._selectedCompareDistrictTab;} private _selectedCompareDistrictTab: DistrictSalesTabViewModel;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;

    refresh(){
        this.dataContext.refresh();
    }
}
